export default {
  HEADER_ADD_PREFIX: '新增{name}',
  HEADER_EDIT_PREFIX: '編輯{name}：{item}',
}
